import { useEffect, useRef, useState } from "react";
import useBrands from "../../../explorer/hooks/useBrands";
import { useReduxState } from "../../../explorer/redux/hooks";
import { Machine, Site } from "../../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../../configuration/reduxStoreConfig";
import useGoToPage from "../../hook/useGoToPage";
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import {
    PopoverStyled,
    Search,
    SearchContainer,
    SearchField,
    StyleTypographyButton,
    TabsSearch,
    ToolbarStyled,
    useClasses,
} from "./SearchBarSitesMachines.styles";
import ServiceProvider from "../../configuration/ServiceProvider";
import {
    AppIconsClose,
    AppIconsManufactory,
    AppIconsPushpin,
    AppIconsSearch,
} from "../AppIcons";
import {
    AppBar,
    Box,
    Button,
    IconButton,
    InputAdornment,
    Paper,
    Tab,
} from "@mui/material";
import AppCustomTabPanel from "../AppTabPanel/AppCustomTabPanel";
import SkeletonList from "../../pages/SpareParts/HomePage/SkeletonList/SkeletonList";
import SearchNoResults from "../SearchNoResults/SearchNoResults";
import SearchBarSitesList from "./SearchBarSitesList/SearchBarSitesList";
import SearchBarMachinesList from "./SearchBarMachinesList/SearchBarMachinesList";
import useCurrentSite from "../../hook/useCurrentSite";

const SearchBarSitesMachines: React.FC<{
    resultClickMachine?: any;
    context?: string;
    openState?: boolean;
    setOpenState?: any;
    anchorElExternal?: any;
}> = ({
    anchorElExternal,
    openState,
    setOpenState,
    resultClickMachine,
    context = "home",
}) => {
    const [open, setOpen] = useState(
        openState !== undefined ? openState : false
    );
    const [value, setValue] = useState<number | boolean>(
        context === "home" ? false : false
    );
    const SEARCH_ALL_MACHINES = "ALL_MACHINES";

    const [showText, setShowText] = useState(true);
    const [searchText, setSearchText] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(
        anchorElExternal !== undefined ? anchorElExternal : null
    );
    const inputRef = useRef<HTMLInputElement | null>(null);
    const brand = useBrands().currentBrandUrl;
    const [currentSite] = useCurrentSite();
    const [sites, setSites] = useReduxState<Site[]>(
        reduxStoreConfig.sparePartsSites
    );
    const [sitesList, setSitesList] = useState<Site[] | undefined>([]);
    const [machines, setMachines] = useState<Machine[]>();
    const [loadInputMachine, setLoadInputMachine] = useState<
        NodeJS.Timeout | undefined
    >();

    const [_, setCurrentMachine] = useReduxState<Machine>(
        reduxStoreConfig.sparePartsCurrentMachine
    );
    const goToPage = useGoToPage();
    const { t } = useTranslation();
    const classes = useClasses();

    useEffect(() => {
        if (open) {
            context == "search" ? handleSearchOpen() : resetSearch(true);
        }
    }, [open, openState]);

    useEffect(() => {
        setOpen(openState!);
    }, [openState]);

    useEffect(() => {
        // if (!searchText) return; // Non può essere undefined
        const _s = searchText;
        if (
            context == "search" ||
            (searchText?.trim() !== "" && searchText.trim().length >= 2)
        )
            search(searchText!.trim());
        else {
            clearTimeout(loadInputMachine);
            resetSearch(true);
            setLoading(false);
        }
    }, [searchText]);

    const goToPagheMachine = (machine: Machine) => {
        goToPage.spareParts.goToMachine(
            machine.customerSiteCode!,
            machine.id!.toString()
        );
    };
    const handleResultClickMachine = (machine: Machine) => {
        setOpen(false);
        setCurrentMachine(machine);
        resetSearch(true);
        setSearchText("");

        resultClickMachine === undefined
            ? goToPagheMachine(machine)
            : resultClickMachine(machine);
    };

    const handleSearchOpen = () => {
        search("");
        setTimeout(() => {
            if (inputRef.current) inputRef.current.focus();
        }, 300);
    };

    const handleClickOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
        setOpen(true);
        /*
        ServiceProvider.SpareParts.getSites(brand)
            .then((result) => setSites(result))
            .catch((error) => console.error(error));
*/
        setTimeout(() => {
            if (inputRef.current) inputRef.current.focus();
        }, 300);
    };

    const handleClose = () => {
        if (setOpenState !== undefined) {
            setOpenState(false);
        }
        setAnchorEl(null);
        resetSearch(true);
        setSearchText("");
        setOpen(false);
    };

    const resetSearch = (init: boolean) => {
        setSitesList(undefined);
        setMachines(undefined);
        if (init) {
            setValue(context === "home" ? false : 1);
            setShowText(true);
        }
    };

    const onSearchHandle = (val: string) => {
        setSearchText(val);
        if ((context !== "search" && !val) || val === "") {
            resetSearch(true);
        }
    };

    const handleClickCancelSearch = () => {
        onSearchHandle("");
        setLoading(false);
    };

    const handleMouseDownCancelSearch = (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();
    };

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    const search = (_valPar: string) => {
        if (loadInputMachine !== undefined) {
            clearTimeout(loadInputMachine);
        }

        if (_valPar === undefined || _valPar === "") {
            if (context == "search") {
                _valPar = SEARCH_ALL_MACHINES;
            } else {
                resetSearch(true);
                return;
            }
        }
        const val = _valPar;
        setLoading(true);
        resetSearch(false);
        setShowText(false);

        var timeout = setTimeout(async function () {
            ServiceProvider.SpareParts.getMachinesSearched(brand, val)
                .then((machinesResult) => {
                    if (context === "home") {
                        setMachines(machinesResult.slice(0, 100));

                        const sitesFiltered = sites.filter((site) => {
                            const text = `${site?.customerSiteCode}-${
                                site?.customerSiteName
                            } ${site?.address} ${site?.address && "-"} ${
                                site?.city
                            }, ${site?.zipCode} (${site?.country})`;

                            return text
                                .toUpperCase()
                                .includes(val.toUpperCase());
                        });

                        setSitesList(sitesFiltered.slice(0, 100));
                        if (
                            (machinesResult && machinesResult.length > 0) ||
                            (sitesFiltered && sitesFiltered.length > 0)
                        ) {
                            if (machinesResult && machinesResult.length > 0) {
                                setValue(1);
                            }

                            if (sitesFiltered && sitesFiltered.length > 0) {
                                setValue(0);
                            }
                        } else {
                            setValue(false);
                        }
                    } else {
                        const machinesFiltered = machinesResult?.filter(
                            (machine) => {
                                return (
                                    currentSite.customerSiteCode ==
                                    machine.customerSiteCode
                                );
                            }
                        );
                        machinesFiltered.map((_m) => {
                            _m.hasDocument = false;
                            _m.hasEmergList = false;
                            _m.hasMaintList = false;
                        });
                        setValue(1);
                        setMachines(machinesFiltered.slice(0, 100));
                    }
                })
                .catch((error) => {
                    console.error(error);
                })

                .finally(() => {
                    setLoading(false);
                });
        }, 1000);

        setLoadInputMachine(timeout);
    };

    return (
        <SearchContainer className="osh-hint-site-machine-search">
            <Search context={context}>
                {context !== "search" ? (
                    <Button
                        sx={classes.buttonSearch}
                        startIcon={<AppIconsSearch />}
                        fullWidth
                        onClick={handleClickOpen}
                    >
                        <StyleTypographyButton
                            sx={classes.noWrap}
                            context={context}
                            variant="body1"
                        >
                            {t("common.homepagesearchbar.searchtext")}
                        </StyleTypographyButton>
                    </Button>
                ) : (
                    <Box>
                        <StyleTypographyButton
                            sx={classes.noWrap}
                            context={context}
                            variant="body1"
                        >
                            {t("common.spareparts.search.select_machine")}
                        </StyleTypographyButton>
                    </Box>
                )}
                <PopoverStyled
                    anchorOrigin={
                        context === "search"
                            ? { vertical: "bottom", horizontal: "left" }
                            : { vertical: "center", horizontal: "center" }
                    }
                    transformOrigin={
                        context === "search"
                            ? { vertical: "top", horizontal: "left" }
                            : { vertical: "center", horizontal: "center" }
                    }
                    anchorEl={
                        anchorElExternal !== undefined
                            ? anchorElExternal
                            : anchorEl
                    }
                    open={open ?? false}
                    onClose={handleClose}
                    className="searchDialog"
                    context={context}
                >
                    <Box sx={{ typography: "body1", minWidth: "fit-content" }}>
                        <AppBar position="static" sx={classes.appBar}>
                            <ToolbarStyled>
                                <SearchField
                                    id="standard-search"
                                    label={
                                        t(
                                            context !== "search"
                                                ? "common.homepagesearchbar.searchtext"
                                                : "common.spareparts.search.select_machine"
                                        ) as string
                                    }
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={searchText || ""}
                                    inputRef={(input) => {
                                        if (input) {
                                            inputRef.current = input;
                                        }
                                    }}
                                    onChange={(ev) => {
                                        if (
                                            ev.target.value !== "" ||
                                            ev.target.value !== null
                                        ) {
                                            onSearchHandle(ev.target.value);
                                        }
                                    }}
                                    slotProps={{
                                        input: {
                                            disableUnderline: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {searchText &&
                                                        searchText.length >
                                                            0 && (
                                                            <IconButton
                                                                aria-label="Cancel search"
                                                                onMouseDown={
                                                                    handleMouseDownCancelSearch
                                                                }
                                                                onClick={
                                                                    handleClickCancelSearch
                                                                }
                                                                sx={
                                                                    classes.icon
                                                                }
                                                            >
                                                                <AppIconsClose />
                                                            </IconButton>
                                                        )}
                                                </InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                            </ToolbarStyled>
                        </AppBar>

                        <AppBar
                            position="relative"
                            sx={
                                context === "search"
                                    ? { height: "0px", overflowY: "hidden" }
                                    : {}
                            }
                        >
                            <Paper square sx={classes.tabRoot}>
                                <TabsSearch
                                    value={value}
                                    onChange={handleChange}
                                    variant="fullWidth"
                                    indicatorColor="primary"
                                    TabIndicatorProps={
                                        (value === 0 &&
                                            (!sites ||
                                                (sites &&
                                                    sites.length === 0))) ||
                                        (value === 1 &&
                                            (!machines ||
                                                (machines &&
                                                    machines.length === 0)))
                                            ? { style: { height: "0px" } }
                                            : {}
                                    }
                                    aria-label="icon label tabs example"
                                >
                                    {context === "home" && (
                                        <Tab
                                            value={0}
                                            icon={<AppIconsPushpin />}
                                            iconPosition="start"
                                            label={`${t(
                                                "common.homepagesearchbar.spareparts.search.sites"
                                            )}`}
                                            disabled={
                                                !sitesList ||
                                                (sitesList &&
                                                    sitesList.length === 0)
                                            }
                                            sx={
                                                !sitesList ||
                                                (sitesList &&
                                                    sitesList.length === 0)
                                                    ? classes.notActive
                                                    : classes.active
                                            }
                                        />
                                    )}
                                    <Tab
                                        value={1}
                                        icon={<AppIconsManufactory />}
                                        iconPosition="start"
                                        label={t(
                                            "common.homepagesearchbar.spareparts.search.machines"
                                        )}
                                        disabled={
                                            !machines ||
                                            (machines &&
                                                machines.length === 0 &&
                                                searchText !== "")
                                        }
                                        sx={[
                                            !machines ||
                                            (machines && machines.length === 0)
                                                ? classes.notActive
                                                : classes.active,
                                        ]}
                                    />
                                </TabsSearch>
                            </Paper>
                        </AppBar>

                        {context === "home" && (
                            <AppCustomTabPanel value={value} index={0}>
                                {loading ? (
                                    <SkeletonList
                                        mkey={"fake_item_key_sites_"}
                                        rows={5}
                                    />
                                ) : (
                                    sitesList &&
                                    sitesList.length > 0 && (
                                        <SearchBarSitesList
                                            sites={sitesList}
                                            setOpen={setOpen}
                                        />
                                    )
                                )}
                                {!loading &&
                                    sitesList &&
                                    sitesList.length === 0 && (
                                        <SearchNoResults />
                                    )}
                            </AppCustomTabPanel>
                        )}
                        {!showText && (
                            <AppCustomTabPanel value={value} index={1}>
                                {loading ? (
                                    <SkeletonList
                                        mkey={"fake_item_key_machines_"}
                                        rows={5}
                                    />
                                ) : (
                                    machines &&
                                    machines.length > 0 && (
                                        <SearchBarMachinesList
                                            machines={machines}
                                            setOpen={setOpen}
                                            handleResultClickMachine={
                                                handleResultClickMachine
                                            }
                                        />
                                    )
                                )}

                                {!loading &&
                                    machines &&
                                    machines.length === 0 && (
                                        <Box sx={{ height: "100%" }}>
                                            <SearchNoResults />
                                        </Box>
                                    )}
                            </AppCustomTabPanel>
                        )}
                        {(value === false || context === "search") &&
                            (showText || loading) && (
                                <Box sx={classes.container}>
                                    {loading && (
                                        <SkeletonList
                                            mkey={"fake_item_key_none_"}
                                            rows={5}
                                        />
                                    )}
                                    {!loading &&
                                        showText &&
                                        !sitesList &&
                                        !machines && (
                                            <Box
                                                display="flex"
                                                p={1}
                                                sx={classes.searchTextBox}
                                            >
                                                {t(
                                                    "common.homepagesearchbar.search.perform"
                                                )}
                                            </Box>
                                        )}
                                </Box>
                            )}
                    </Box>
                </PopoverStyled>
            </Search>
        </SearchContainer>
    );
};

export default SearchBarSitesMachines;
